import BaseController from 'lib/base-controller';
import Slider from 'lib/slider';
import SocialSlider from 'lib/social-slider';
import Video from 'lib/video';

import InfluencerTemplate from 'templates/influencer.html';
import deauData from 'data/influencers/deau.json';
import charlotteMartinData from 'data/influencers/charlotte-martin.json';
import lisaFiegeData from 'data/influencers/lisa-fiege.json';
import nandaSchwarzData from 'data/influencers/nanda-schwarz.json';
import oliviaByNatureData from 'data/influencers/olivia-by-nature.json';
import urbanTravellerData from 'data/influencers/urban-traveller.json';

export default class InfluencerController extends BaseController {
    constructor (props, renderDone) {
        super();

        this.template = InfluencerTemplate;
        this.context = this.getData(props.name);
        this.renderDone = renderDone;

        this.render();
    }

    /**
     * Destructor
     *
     * @param  {Function} done
     */
    destructor (done) {
        done();
    }

    afterRender () {
        super.afterRender();

        this.initSlider();
        this.initSocialSlider();
        this.initVideo();
        this.loadImage();
    }

    loadImage () {
        let image = document.createElement('img');

        image.onload = this.renderDone;

        image.src = `/media/img/influencers/${this.context.firstName}/${this.context.shortname}_hero.jpg`;

        if (image.complete) {
            this.renderDone();
        }
    }

    initSlider () {
        new Slider(document.querySelector('[data-slider]'));
    }

    initSocialSlider () {
        new SocialSlider(document.querySelector('.js-social-slider'), this.context.socialItems);
    }

    initVideo () {
        new Video(document.querySelector('[data-player="container"]'));
    }

    getData (name) {
        const data = {
            'deau': deauData,
            'charlotte-martin': charlotteMartinData,
            'lisa-fiege': lisaFiegeData,
            'nanda-schwarz': nandaSchwarzData,
            'olivia-by-nature': oliviaByNatureData,
            'urban-traveller': urbanTravellerData,
        }

        return data[name];
    }
}



// WEBPACK FOOTER //
// ./controllers/influencer.js